import * as React from 'react';
import {
	Box,
	Button,
	CloseButton,
	Flex,
	FormControl,
	FormLabel,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Switch,
	Text,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import { Link } from "@chakra-ui/react";
import { useCookies } from 'react-cookie';

interface ICookies {
	cookies: any;
	setCookie: any;
	removeCookie: any;
	onCookieChange: (el: any) => void;
}

const gAnalytics = 'gatsby-gdpr-google-analytics';
const isAccepted = 'is-accepted';
export const gCzater = 'gatsby-czater';
export const allCookiesAccepted = {
	'gatsby-gdpr-google-analytics': 'true',
	'gatsby-czater': 'true',
};

export const Cookies = () => {
	const { useEffect, useRef, useState } = React;
	const [cookies, setCookie, removeCookie] = useCookies([]);

	const [active, setActive] = useState(false);
	const analyticsRef = useRef();
	const [isOpenCookiePreferences, handleIsOpenCookiePreferences] = useState(false);

	useEffect(() => {
		setCookie(gCzater, true);
		if (cookies[isAccepted] === undefined) {
			const analytics = !!cookies[gAnalytics];
			setActive(true);
			if (!analytics) {
				setCookie(gAnalytics, true);
			}
		} else if (cookies[isAccepted] === 'true') {
			setActive(false);
		} else {
			setActive(true);
		}
	}, []);

	const closeCookies = () => {
		setActive(false);
	};

	const acceptAll = () => {
		setActive(false);
		setCookie(gAnalytics, true);
		setCookie(isAccepted, true);
	};

	const acceptCustom = () => {
		handleIsOpenCookiePreferences(false);
		setActive(false);
		const acceptedCookies = {};
		const aref: any = analyticsRef?.current;
		if (aref?.checked) {
			setCookie(gAnalytics, true);
			acceptedCookies[gAnalytics] = 'true';
		}
		// if(requredRef.current.checked) {
		//     setCookie(gCzater, true)
		//     acceptedCookies[gCzater] = "true"
		// }
	};

	const declineAll = () => {
		Object.keys(cookies).forEach((item) => {
			removeCookie(item);
		});
		setCookie(isAccepted, false);
		removeCookie(gAnalytics);
		setActive(false);
	};

	const handleModalOpen = (isOpen: boolean) => {
		handleIsOpenCookiePreferences(isOpen);
	};

	return (
		<>
			<Modal isOpen={isOpenCookiePreferences} onClose={() => handleModalOpen(false)}>
				<ModalOverlay />
				<ModalContent m="20px 15px" background="#F5F5F5" maxWidth="700px" py="20px" px="30px">
					<ModalHeader>Preferencje Cookies:</ModalHeader>
					<ModalCloseButton onClick={() => handleModalOpen(false)} />
					<ModalBody>
						{/* <FormControl display='flex' alignItems='center'> */}
						{/*    <Switch ref={requredRef} id="all-cookies" colorScheme='teal' defaultChecked={true} size='lg'/> */}
						{/*    <FormLabel fontSize="14px" htmlFor='all-cookies' ml='15px'> */}
						{/*        Cookies niezbędnych używamy do tego by strona działała prawidłowo. */}
						{/*    </FormLabel> */}
						{/* </FormControl> */}
						{/* <Box borderBottom='1px solid #8d9098' m="10px 50px"/> */}
						<FormControl mt="20px" display="flex" alignItems="center">
							<Switch ref={analyticsRef} id="g-cookies" defaultChecked colorScheme="teal" size="lg" />
							<FormLabel fontSize="14px" htmlFor="g-cookies" ml="15px">
								Narzędzie służące do analizy ruchu na stronie bez gromadzenia żadnych danych pozwalających na Twoją bezpośrednią
								identyfikację. Informacje, które pozyskujemy to m. in. czas spędzony na stronie, przejścia pomiędzy poszczególnymi
								podstronami. Wyłączenie Google Analytics pozbawi nas możliwości tworzenia coraz lepszych rozwiązań dla odwiedzających
								naszą stronę.
							</FormLabel>
						</FormControl>
						<Flex mt="10px" justifyContent="center">
							<Button onClick={acceptCustom} fontWeight="700" color="white" background="#50C877">
								Zakończ i zaakceptuj wybrane
							</Button>
						</Flex>
					</ModalBody>
				</ModalContent>
			</Modal>
			{active && !isOpenCookiePreferences && (
				<Box
					borderRadius={10}
					// boxShadow="0px 0px 10px rgba(0, 0, 0, 0.6);"
					// p="5px 10px"
					p="40px"
					opacity={1}
					zIndex={100000}
					background="white"
					right={0}
					bottom="0"
					position="fixed"
					mb="20px"
					// m={{base: 0, md: '0 20px 20px 20px'}}
				>
					<Flex alignItems="center" pos="relative" justifyContent="space-between">
						{/* <Text fontWeight="700" fontSize={17} m={0}> */}
						{/*	Polityka Cookie */}
						{/* </Text> */}
						<Flex
							cursor="pointer"
							justifyContent="center"
							alignItems="center"
							w="50px"
							h="50px"
							top="-65px"
							borderRadius="50%"
							bg="#D1E6FF"
							right="0"
							pos="absolute"
							onClick={closeCookies}
						>
							<CloseIcon fontSize="17px" />
						</Flex>
					</Flex>
					<Flex d={{ base: 'block', lg: 'flex' }}>
						<Box m={0}>
							Strona wykorzystuje pliki cookies w celu prawidłowego jej działania, korzystania z narzędzi analitycznych (Google Analytics). Szczegóły znajdziesz w polityce prywatności. Jeśli wyrażasz zgodę na wykorzystywanie plików cookies, kliknij w przycisk „Rozumiem i akceptuję”
						</Box>
						<Flex
							flexDirection="column"
							mt={{ base: '25px', lg: 0 }}
							ml={{ base: '0', lg: '30px' }}
							justifyContent="space-between"
							alignItems="center"
						>
							<Button
								fontSize="14px"
								h="37px"
								p="8px 0"
								w={{ base: '100%', lg: '386px' }}
								bg="#222C63"
								fontWeight="700"
								onClick={acceptAll}
								color="white"
							>
								ROZUMIEM I AKCEPTUJĘ
							</Button>
							<Flex justifyContent="center">
								<Link to={`${window.location.origin}/polityka-prywatnosci-bloga`} className="site-foot-nav-link">
									Polityka Prywatności
								</Link>
							</Flex>

							{/* <Button fontWeight="700" onClick={declineAll} color="white"> */}
							{/*	Nie zgadzam się */}
							{/* </Button> */}
							{/* <Button fontWeight="700" onClick={() => handleModalOpen(true)} color="white" background="#6f93b9"> */}
							{/*    Preferencje cookies */}
							{/* </Button> */}
						</Flex>
					</Flex>
				</Box>
			)}
		</>
	);
};

export default Cookies;
